import Calculater from './components/Calculater';

function App() {
  return (
    <div>
      <Calculater />
    </div>
  );
}

export default App;
